<template>
    <div>
        <v-dialog v-model="crudDialog" fullscreen persistent>
            <v-card>
                <v-toolbar card color="primary" class="white--text" >
                    <v-toolbar-title><h4>{{ formTitle }}</h4></v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs12 sm6>
                                <v-text-field
                                        v-model="editedItem.cuit"
                                        label="Cuit"
                                        placeholder="Cuit"
                                        :error-messages="cuitErrors"
                                        :counter="12"
                                        mask="##-########-#"
                                        required
                                        @input="$v.editedItem.cuit.$touch()"
                                        @blur="$v.editedItem.cuit.$touch()"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-text-field
                                        v-model="editedItem.nombre"
                                        label="Apellido y Nombre/ Razón Social"
                                        placeholder="Apellido y Nombre / Razón Social"
                                        :error-messages="nombreErrors"
                                        :counter="80"
                                        required
                                        @input="$v.editedItem.nombre.$touch()"
                                        @blur="$v.editedItem.nombre.$touch()"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-text-field
                                        v-model="editedItem.email"
                                        label="Email"
                                        :error-messages="emailErrors"
                                        @input="$v.editedItem.email.$touch()"
                                        @blur="$v.editedItem.email.$touch()"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-text-field
                                        v-model="editedItem.email_alternativo"
                                        label="Email Laboral"
                                        :error-messages="emailAlternativoErrors"
                                        @input="$v.editedItem.email_alternativo.$touch()"
                                        @blur="$v.editedItem.email_alternativo.$touch()"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-text-field
                                        v-model="editedItem.telefono"
                                        label="Teléfono"
                                        :error-messages="telefonoErrors"
                                        @input="$v.editedItem.telefono.$touch()"
                                        @blur="$v.editedItem.telefono.$touch()"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-text-field
                                        v-model="editedItem.direccion"
                                        label="Dirección"
                                        :error-messages="direccionErrors"
                                        @input="$v.editedItem.direccion.$touch()"
                                        @blur="$v.editedItem.direccion.$touch()"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-text-field
                                        v-model="editedItem.localidad"
                                        label="Localidad"
                                        :error-messages="localidadErrors"
                                        @input="$v.editedItem.localidad.$touch()"
                                        @blur="$v.editedItem.localidad.$touch()"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-text-field
                                        v-model="editedItem.codigo_postal"
                                        label="Código Postal"
                                        :error-messages="codigoPostalErrors"
                                        @input="$v.editedItem.codigo_postal.$touch()"
                                        @blur="$v.editedItem.codigo_postal.$touch()"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-select
                                        :items="provincias"
                                        v-model="editedItem.provincia"
                                        :error-messages="provinciaErrors"
                                        label="Provincia"
                                        item-text="nombre"
                                        item-value="id"
                                        hide-details
                                        return-object
                                ></v-select>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-dialog
                                        ref="dialogFn"
                                        v-model="modalFn"
                                        :return-value.sync="editedItem.fecha_nacimiento_string"
                                        persistent
                                        lazy
                                        full-width
                                        width="290px"
                                >
                                    <v-text-field
                                            slot="activator"
                                            v-model="computedFechaNacimiento"
                                            label="Fecha Nacimiento"
                                            append-icon="event"
                                            readonly
                                    ></v-text-field>
                                    <v-date-picker v-model="editedItem.fecha_nacimiento_string" scrollable locale="es-ar">
                                        <v-spacer></v-spacer>
                                        <v-btn flat color="primary" @click="modalFn = false">Cancelar</v-btn>
                                        <v-btn flat color="primary" @click="$refs.dialogFn.save(editedItem.fecha_nacimiento_string)">OK</v-btn>
                                    </v-date-picker>
                                </v-dialog>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-select
                                        :items="asesores"
                                        v-model="editedItem.asesor"
                                        :error-messages="asesorErrors"
                                        label="Asesor"
                                        item-text="nombre"
                                        item-value="id"
                                        hide-details
                                        return-object
                                ></v-select>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-select
                                        :items="derivadores"
                                        v-model="editedItem.derivador"
                                        :error-messages="derivadorErrors"
                                        label="Derivador"
                                        item-text="nombre"
                                        item-value="id"
                                        hide-details
                                        return-object
                                ></v-select>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-switch
                                        label="Habilitado"
                                        v-model="editedItem.enabled"
                                ></v-switch>
                            </v-flex>
                        </v-layout>
                    </v-container>

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" :disabled="$v.$invalid" @click.native="save">Guardar</v-btn>
                    <v-btn color="secondary" @click.native="close">Cancelar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-card>
            <v-toolbar card>
                <v-btn
                    fab
                    small
                    color="success"
                    bottom
                    left
                    absolute
                    @click="addItem"
                    >
                    <v-icon>add</v-icon>
                </v-btn>


                <v-toolbar-title><h4>Gestión de Tomadores</h4></v-toolbar-title>
                <v-spacer></v-spacer>
                <v-text-field
                        v-model="searchFilter.name"
                        append-icon="search"
                        label="Buscar"
                        single-line
                        @change="onSearchfilterChanged"
                        hide-details
                ></v-text-field>
            </v-toolbar>
            <v-card-text class="pa-0">
                <template>
                    <v-data-table
                            :headers="headers"
                            :items="items"
                            :total-items="totalItems"
                            :pagination.sync="pagination"
                            :loading="loading"
                            :hide-actions="loading"
                            :rows-per-page-items="itemsPerPage"
                            class="elevation-0"
                    >
                        <template slot="items" slot-scope="props">
                            <td>{{ props.item.nombre }}</td>
                            <td>{{ props.item.email }}</td>
                            <td>{{ props.item.telefono }}</td>
                            <td><v-icon>{{ props.item.enabled ? 'check' : 'close' }}</v-icon></td>
                            <td>{{ props.item.created.format('DD-MM-YYYY hh:mm') }}</td>
                            <td class="text-xs-right">
                                <v-btn flat icon color="teal" @click="editItem(props.item)">
                                    <v-icon>edit</v-icon>
                                </v-btn>
                                <v-btn flat v-if="user.roles.includes('ADMINISTRADOR')" icon color="pink" @click="deleteItem(props.item)">
                                    <v-icon>delete</v-icon>
                                </v-btn>
                            </td>
                        </template>
                    </v-data-table>
                </template>
                <v-divider></v-divider>
            </v-card-text>
            <v-snackbar color="error" error v-if="error" :timeout="errorTimeout" :bottom="true"
                        v-model="error">
                {{ errorMessage }}
                <v-btn secondary flat @click.native="error = false">Close</v-btn>
            </v-snackbar>
            <v-snackbar color="success" v-if="success" :timeout="successTimeout" :bottom="true"
                        v-model="success">
                {{ successMessage }}
            </v-snackbar>
        </v-card>
    </div>

</template>

<script>
  import { required, maxLength, email } from 'vuelidate/lib/validators'
  import {phoneValidator, cuitValidator} from '@/util/validators'
  import moment from 'moment'
  import qs from 'qs'
  import store from '@/store'

  export default {
    data () {
      return {
        error: false,
        errorMessage: '',
        errorTimeout: 6000,
        success: false,
        successMessage: '',
        successTimeout: 2000,
        searchFilter: {
          name: ''
        },
        items: [],
        totalItems: 0,
        pagination: {
          page: 1,
          search: ''
        },
        crudDialog: false,
        editedIndex: -1,
        editedItem: {
          id: '',
          cuit: '',
          nombre: '',
          email: '',
          email_alternativo: '',
          enabled: true,
          telefono: '',
          direccion: '',
          localidad: '',
          codigo_postal: '',
          fecha_nacimiento_string: '',
          fecha_nacimiento: null,
          asesor: null,
          asesor_id: null,
          derivador: null,
          derivador_id: null,
          provincia: {id: '1', nombre: 'Santa Fe'},
          provincia_id: '1',
          created: moment(),
          updated: moment()
        },
        defaultItem: {
          id: '',
          cuit: '',
          nombre: '',
          email: '',
          email_alternativo: '',
          enabled: true,
          telefono: '',
          direccion: '',
          localidad: '',
          codigo_postal: '',
          fecha_nacimiento_string: '',
          fecha_nacimiento: null,
          asesor: null,
          asesor_id: null,
          derivador: null,
          derivador_id: null,
          provincia: {id: '1', nombre: 'Santa Fe'},
          provincia_id: '1',
          created: moment(),
          updated: moment()
        },
        modalFn: false,
        asesores: [],
        derivadores: [],
        provincias: [],
        loading: false,
        headers: [
          {
            text: 'Nombre / Razón Social',
            align: 'left',
            sortable: true,
            value: 'nombre'
          },
          {
            text: 'Email',
            align: 'left',
            sortable: true,
            value: 'email'
          },
          {
            text: 'Teléfono',
            align: 'left',
            sortable: false,
            value: 'telefono'
          },
          {
            text: 'Habilitado',
            align: 'left',
            sortable: true,
            value: 'enabled'
          },
          {
            text: 'Creado',
            align: 'left',
            sortable: true,
            value: 'created'
          },
          { text: 'Acciones', value: 'action', align: 'right', sortable: false }
        ]
      }
    },
    computed: {
      user () {
        return store.getters['user/user']
      },
      itemsPerPage () {
        return store.getters['itemsPerPage']
      },
      formTitle () {
        return this.editedIndex === -1 ? 'Nuevo Tomador' : 'Editar Tomador'
      },
      computedFechaNacimiento () {
        if (this.editedItem.fecha_nacimiento_string !== '') {
          return moment(this.editedItem.fecha_nacimiento_string).format('DD/MM/YYYY')
        }
        return ''
      },
      cuitErrors () {
        let errors = []
        if (!this.$v.editedItem.cuit.$dirty) return errors
        !this.$v.editedItem.cuit.cuitValidator && errors.push('CUIT inválido')
        !this.$v.editedItem.cuit.required && errors.push('El CUIT es requerido.')
        return errors
      },
      nombreErrors () {
        let errors = []
        if (!this.$v.editedItem.nombre.$dirty) return errors
        !this.$v.editedItem.nombre.maxLength && errors.push('Máximo 60 caracteres')
        !this.$v.editedItem.nombre.required && errors.push('El nombre es requerido.')
        return errors
      },
      derivadorErrors () {
        let errors = []
        if (!this.$v.editedItem.derivador.$dirty) return errors
        !this.$v.editedItem.derivador.required && errors.push('El derivador es requerido.')
        return errors
      },
      asesorErrors () {
        let errors = []
        if (!this.$v.editedItem.asesor.$dirty) return errors
        !this.$v.editedItem.asesor.required && errors.push('El asesor es requerido.')
        return errors
      },
      emailErrors () {
        let errors = []
        if (!this.$v.editedItem.email.$dirty) return errors
        !this.$v.editedItem.email.required && errors.push('Email requerido.')
        !this.$v.editedItem.email.email && errors.push('Email inválido')
        return errors
      },
      emailAlternativoErrors () {
        let errors = []
        if (!this.$v.editedItem.email_alternativo.$dirty) return errors
        !this.$v.editedItem.email_alternativo.email && errors.push('Email inválido')
        return errors
      },
      telefonoErrors () {
        let errors = []
        if (!this.$v.editedItem.telefono.$dirty) return errors
        !this.$v.editedItem.telefono.required && errors.push('Teléfono requerido.')
        !this.$v.editedItem.telefono.phoneValidator && errors.push('Teléfono inválido')
        return errors
      },
      direccionErrors () {
        let errors = []
        if (!this.$v.editedItem.direccion.$dirty) return errors
        !this.$v.editedItem.direccion.maxLength && errors.push('Máximo 30 caracteres')
        !this.$v.editedItem.direccion.required && errors.push('La dirección es requerida.')
        return errors
      },
      localidadErrors () {
        let errors = []
        if (!this.$v.editedItem.localidad.$dirty) return errors
        !this.$v.editedItem.localidad.maxLength && errors.push('Máximo 30 caracteres')
        !this.$v.editedItem.localidad.required && errors.push('La localidad es requerida.')
        return errors
      },
      provinciaErrors () {
        let errors = []
        if (!this.$v.editedItem.provincia.$dirty) return errors
        !this.$v.editedItem.provincia.required && errors.push('La provincia es requerida.')
        return errors
      },
      codigoPostalErrors () {
        let errors = []
        if (!this.$v.editedItem.codigo_postal.$dirty) return errors
        !this.$v.editedItem.codigo_postal.maxLength && errors.push('Máximo 10 caracteres')
        !this.$v.editedItem.codigo_postal.required && errors.push('El código postal es requerido.')
        return errors
      }
    },
    methods: {
      getDataFromApi () {
        this.loading = true
        const {sortBy, descending, page, rowsPerPage, search} = this.pagination
        this.axios.post('/clientes',
          qs.stringify(
            {
              page,
              rowsPerPage,
              sortBy,
              descending,
              search
            })).then(
          response => {
            this.items = response.data.data.map(function (item) {
              item.created = moment(item.created)
              item.updated = moment(item.updated)
              if (item.fecha_nacimiento) {
                item.fecha_nacimiento_string = moment(item.fecha_nacimiento).format('YYYY-MM-DD')
              } else {
                item.fecha_nacimiento_string = ''
              }
              return item
            })
            this.totalItems = response.data.total_entries
            this.loading = false
          }
        ).catch(
          err => {
            console.log(err)
            this.loading = false
            this.errorMessage = 'Error al cargar listado'
            this.error = true
          }
        )
      },
      addItem () {
        this.crudDialog = true
        this.editedItem = JSON.parse(JSON.stringify(this.defaultItem))
        this.editedIndex = -1
        this.$v.$reset()
      },
      deleteItem (item) {
        this.$root.$confirm('Borrar Cliente', `¿Está seguro de borrar el cliente ${item.nombre} ?`, { color: 'error' }).then(
          (confirm) => {
            if (confirm === true) {
              this.axios.delete('/clientes/delete/' + item.id).then(
                _ => {
                  this.successMessage = 'Cliente borrado exitosamente.'
                  this.success = true
                  this.getDataFromApi()
                  this.close()
                }
              ).catch(
                _ => {
                  this.errorMessage = 'Error al borrar el cliente'
                  this.error = true
                  this.close()
                }
              )
            }
          },
          (reject) => { console.log(reject) })
      },
      editItem (item) {
        this.editedIndex = this.items.indexOf(item)
        this.editedItem = JSON.parse(JSON.stringify(item))
        this.editedItem.created = moment(this.editedItem.created)
        this.editedItem.updated = moment(this.editedItem.updated)
        this.crudDialog = true
      },
      close () {
        this.crudDialog = false
        setTimeout(() => {
          this.editedItem = JSON.parse(JSON.stringify(this.defaultItem))
          this.$v.$reset()
        }, 300)
      },
      save () {
        let url = ''
        if (this.editedIndex > -1) {
          url = '/clientes/update'
        } else {
          url = '/clientes/add'
        }
        if (this.editedItem.fecha_nacimiento_string) {
          this.editedItem.fecha_nacimiento = moment(this.editedItem.fecha_nacimiento_string)
        }
        this.axios.post(url, this.editedItem).then(
          _ => {
            this.successMessage = 'Cliente guardado exitosamente.'
            this.success = true
            this.getDataFromApi()
            this.close()
          }
        ).catch(
          _ => {
            this.errorMessage = 'Error al guardar cliente.'
            this.error = true
            this.close()
          }
        )
      },
      onSearchfilterChanged () {
        this.pagination.search = this.searchFilter.name
        this.pagination.page = 1
      },
      getAsesores () {
        this.$store.dispatch('setDisabledLoading', true)
        this.axios.get('/asesores/search', { params: { search: '' } })
          .then(res => {
            this.asesores = res.data
          })
          .catch(err => {
            console.log(err)
          })
          .finally(() => (this.$store.dispatch('setDisabledLoading', false)))
      },
      getDerivadores () {
        this.$store.dispatch('setDisabledLoading', true)
        this.axios.get('/derivadores/search', { params: { search: '' } })
          .then(res => {
            this.derivadores = res.data
          })
          .catch(err => {
            console.log(err)
          })
          .finally(() => (this.$store.dispatch('setDisabledLoading', false)))
      },
      getProvincias () {
        this.$store.dispatch('setDisabledLoading', true)
        this.axios.get('/provincias/search', { params: { search: '' } })
          .then(res => {
            this.provincias = res.data
          })
          .catch(err => {
            console.log(err)
          })
          .finally(() => (this.$store.dispatch('setDisabledLoading', false)))
      }
    },
    validations: {
      editedItem: {
        nombre: {required, maxLength: maxLength(30)},
        cuit: {required, cuitValidator},
        direccion: {required, maxLength: maxLength(100)},
        localidad: {required, maxLength: maxLength(100)},
        codigo_postal: {required, maxLength: maxLength(10)},
        asesor: {required},
        derivador: {required},
        provincia: {required},
        email: {required, email},
        email_alternativo: {email},
        telefono: {required, phoneValidator}
      }
    },
    watch: {
      pagination: {
        handler () {
          this.getDataFromApi()
        },
        deep: true
      }
    },
    components: {
    },
    mounted () {
      this.getAsesores()
      this.getDerivadores()
      this.getProvincias()
    },
    name: 'ClienteList'
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Management/ClienteList.vue